import { useLocation } from "react-router-dom";

export default function useMatchParams() {
  const location = useLocation();

  return {
    statusId: +location?.pathname?.split("/")?.[2],
  };
}
